import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { FiCheck, FiMessageCircle, FiRefreshCw } from 'react-icons/fi';
import { toast } from '../../Toast';
import { useClient } from '../clientSettingsData';
import { WIDGETS, findWidget } from './catalog';
import WidgetsConnect from './WidgetsConnect';
import WidgetList from './WidgetList';
import WidgetDetail from './WidgetDetail';

// Client settings › Widgets. /client-settings/widgets = step 1 Connect, /widgets/list = step 2 the widget list,
// /widgets/{slug} = one widget. Preview only: no website check or key management exists yet.
const Widgets: React.FC = () => {
    const { section = '' } = useParams<{ section?: string }>();
    const widget = section && section !== 'list' ? findWidget(section) : undefined;
    if (widget) return <WidgetDetail widget={widget} />;
    return <WidgetSteps step={section === 'list' ? 2 : 1} />;
};

export const missingCount = () => WIDGETS.filter(w => !w.installed).length;

const WidgetSteps: React.FC<{ step: 1 | 2 }> = ({ step }) => {
    const history = useHistory();
    const { name } = useClient();
    const installed = WIDGETS.length - missingCount();

    return <div className="widgets-v2">
        <div className="page-header">
            <div>
                <h1>Website Widgets — {name}</h1>
                <p>{missingCount()} missing</p>
            </div>
            {step === 2 && <div className="action-top"><CheckNowButton /></div>}
        </div>

        <div className="wd-row">
            <nav className="wd-steps" aria-label="Setting up">
                <div className="nav-title">Setting up</div>
                <button type="button" className={step === 1 ? 'active' : ''} onClick={() => history.push('/client-settings/widgets')}>
                    <span className="n done"><FiCheck /></span>
                    <span className="t"><strong>Connect</strong><span>API keys and domains</span></span>
                </button>
                <button type="button" className={step === 2 ? 'active' : ''} onClick={() => history.push('/client-settings/widgets/list')}>
                    <span className="n">2</span>
                    <span className="t"><strong>Widgets</strong><span>{installed} of {WIDGETS.length} on the website</span></span>
                </button>
                <hr />
                <div className="help">
                    <div className="nav-title">Need a hand?</div>
                    <p>Send the code to your web developer, or ask Investi support to install it for you.</p>
                    <button type="button" className="btn-outline with-icon small" onClick={() => toast.info('Preview only: no request was sent to Investi support')}>
                        <FiMessageCircle /> Ask Investi to Install It
                    </button>
                </div>
            </nav>
            <div className="wd-main">
                {step === 1 ? <WidgetsConnect /> : <WidgetList />}
            </div>
        </div>
    </div>;
};

const CheckNowButton: React.FC = () => {
    const [checking, setChecking] = React.useState(false);
    const check = () => {
        setChecking(true);
        setTimeout(() => {
            setChecking(false);
            toast.info('Preview only: the website wasn’t checked');
        }, 1200);
    };
    return <button type="button" className="btn-outline with-icon" onClick={check} disabled={checking}>
        <FiRefreshCw className={checking ? 'spin' : ''} /> {checking ? 'Checking…' : 'Check Website Now'}
    </button>;
};

export default Widgets;
